import { useSyncExternalStore } from "react";

function getMediaQuery() {
    return window?.matchMedia("(prefers-color-scheme: light)");
}

function subscribe(callback: () => void) {
    const mediaQuery = getMediaQuery();

    mediaQuery?.addEventListener("change", callback);

    return () => mediaQuery?.removeEventListener("change", callback);
}

function getPrefersColorScheme() {
    const mediaQuery = getMediaQuery();

    return mediaQuery?.matches ? "light" : "dark";
}

export function usePrefersColorScheme() {
    return useSyncExternalStore(subscribe, getPrefersColorScheme);
}
